import Intake from './intake';

const internals = {
    initializers: [Intake],
};

export default (store) => {
    internals.initializers.forEach((init) => init(store));
};
